import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import noop from 'lodash/noop';

import theme from './DeprecatedTooltip.scss';

class DeprecatedTooltip extends Component {
  static propTypes = {
    allowMultiline: PropTypes.bool,
    children: PropTypes.node.isRequired,
    fields: PropTypes.object,
    hideOnMouseOut: PropTypes.bool,
    messageRootClassName: PropTypes.string,
    message: PropTypes.node,
    rtl: PropTypes.bool,
    width: PropTypes.string,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    allowMultiline: false,
    fields: {},
    hideOnMouseOut: false,
    messageRootClassName: '',
    message: undefined,
    rtl: true,
    width: 'auto',
    onClick: noop,
  };

  constructor(props) {
    super(props);

    this.getContainerRef = new Promise((resolve) => {
      this.getContainerRefResolver = resolve;
    });
    this.getMessageRef = new Promise((resolve) => {
      this.getMessageRefResolver = resolve;
    });

    this.state = {};
  }

  componentDidMount() {
    this.update();
    window.addEventListener('resize', this.update);
    document.addEventListener('scroll', this.update);
  }

  componentWillReceiveProps({ fields }) {
    if (fields !== this.props.fields) {
      this.update();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.update);
    document.removeEventListener('scroll', this.update);
  }

  update = () => {
    Promise.all([this.getContainerRef, this.getMessageRef]).then(([containerRef, messageRef]) => {
      const { rtl } = this.props;

      const { bottom, left, right } = ReactDOM.findDOMNode(containerRef).getBoundingClientRect(); // eslint-disable-line
      const { width } = ReactDOM.findDOMNode(messageRef).getBoundingClientRect(); // eslint-disable-line

      this.setState({
        width,
        messageTop: bottom,
        messageLeft: rtl ? `${ right - width }px` : left,
      });
    });
  };

  render() {
    const {
      children,
      message,
      width,
      rtl,
      hideOnMouseOut,
      messageRootClassName,
      allowMultiline,
      onClick,
    } = this.props;

    if (!children) {
      return null;
    }

    return (
      <div
        className={ classnames(theme.root) }
        onClick={ onClick }
      >
        <div
          className={ theme.childContainer }
          ref={ (ref) => this.getContainerRefResolver(ref) }
        >
          { children }
        </div>
        { message && (
          <div
            className={ classnames(theme.messageContainer, messageRootClassName, {
              [theme.hideOnMouseOut]: hideOnMouseOut,
            }) }
            style={{
              top: `${ this.state.messageTop - 4 }px`,
              left: this.state.messageLeft,
            }}
          >
            <div className={ theme.messageRoot }>
              <div
                style={{
                  transform: `translate(${ rtl ? `${ this.state.width - 37 }px` : '32px' }, -13px)`,
                }}
                className={ theme.triangleContainer }
              >
                <div className={ classnames(theme.arrowUp, theme.triangle) } />
                <div className={ classnames(theme.arrowUp, theme.triangle, theme.bg) } />
              </div>
              <div
                ref={ (ref) => this.getMessageRefResolver(ref) }
                className={ classnames(theme.contentContainer, {
                  [theme.allowMultiline]: allowMultiline,
                }) }
                style={{
                  width,
                }}
              >
                { message }
              </div>
            </div>
          </div>
        ) }
      </div>
    );
  }
}

export default DeprecatedTooltip;
